import { Platform } from "../../../../features/api/apiSlice";

export interface PlatformFeature {
  id: string;
  name: string;
  platforms: Platform[];
}

export const platformFeatures: PlatformFeature[] = [
  {
    id: "multichat",
    name: "Мультичат",
    platforms: ["twitch", "youtube", "trovo", "vk", "gg", "vk_video_live", "kick", "telegram", "rutube"],
  },
  {
    id: "title_update",
    name: "Смена названия и описания",
    platforms: ["twitch", "youtube", "trovo", "vk", "gg", "vk_video_live", "kick"],
  },
  {
    id: "transcoding",
    name: "Транскодинг",
    platforms: ["twitch", "youtube", "trovo", "vk", "gg", "vk_video_live", "kick", "telegram", "rutube", "boosty", "platform", "ok"],
  },
  {
    id: "scheduled_streams",
    name: "Планирование эфиров",
    platforms: ["twitch", "youtube", "trovo", "vk", "gg", "vk_video_live", "kick", "telegram", "rutube", "boosty", "platform", "ok"],
  },
];

export const getPlatformFeatures = (platform: Platform): PlatformFeature[] => {
  return platformFeatures.filter(feature => feature.platforms.includes(platform));
};